import { render } from "./navigation.vue?vue&type=template&id=13175e76&scoped=true&ts=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"

import "./navigation.vue?vue&type=style&index=0&id=13175e76&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13175e76"]])

export default __exports__